var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiocredit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_119_31",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 24,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24774 7.38374L8.15884 11.2948C9.04661 10.5846 10.1248 10.1231 11.3124 9.98947V4.4541C8.60788 4.61257 6.15228 5.68952 4.24774 7.38374ZM3.27545 8.35603C1.43789 10.4216 0.265137 13.1326 0.265137 16.1083C0.265137 16.4883 0.572672 16.7959 0.952726 16.7959H5.1241C5.50415 16.7959 5.81169 16.4883 5.81169 16.1083C5.81169 14.65 6.33962 13.3259 7.18655 12.2671L3.27545 8.35603ZM17.3127 10.7318C17.081 10.5297 16.7453 10.5036 16.4894 10.6694C14.159 12.1559 12.8525 12.9894 10.5221 14.4759C9.72503 14.9849 9.24963 15.8518 9.24963 16.7959C9.24963 18.3127 10.4831 19.5462 12 19.5462C13.0663 19.5462 14.0453 18.9218 14.4938 17.9555L17.4826 11.5389C17.5453 11.4041 17.5627 11.2526 17.5321 11.1071C17.5014 10.9616 17.4245 10.8299 17.3127 10.7318ZM20.7245 8.35603L18.7036 10.377C18.9581 10.9202 18.9915 11.5562 18.7288 12.1197L17.8247 14.0608C18.0575 14.7002 18.1883 15.3875 18.1883 16.1083C18.1883 16.4883 18.4958 16.7959 18.8759 16.7959H23.0473C23.4273 16.7959 23.7348 16.4883 23.7348 16.1083C23.7348 13.1326 22.5621 10.4216 20.7245 8.35603ZM12.6876 4.4541V9.98947C13.2665 10.0546 13.8181 10.2003 14.3356 10.4121L15.7502 9.50967C16.3169 9.14241 17.0094 9.06361 17.7307 9.40529L19.7522 7.38374C17.8477 5.68952 15.3921 4.61257 12.6876 4.4541Z",
    fill: "#ABE0DD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_119_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.814496 4.58524L26 2.96359L24.9387 20.5933L-3.65299 20.2337L0.814496 4.58524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1034 11.0215L17.8689 9.99003L17.4242 19.3779L8.6231 20.2842L10.1034 11.0215Z",
    fill: "#ADDE34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiocredit);
export default __webpack_public_path__ + "static/media/Biocredit.39ce82b19622ed40e1c6f5e9433478e4.svg";
export { ForwardRef as ReactComponent };